import React, { useState } from 'react'
import { Spinner, Typography } from '@telavita-core/react-design-kit'

import { useUpdatePersonGeneral } from 'hooks'
import { AddressInputFields } from 'components/PatientData'
import ModalGeneric from 'containers/ModalManager/Modals/ModalGeneric'

import { AddressFormMethods } from './useEditAddressForm'

import * as S from './styles'

interface EditAddressModalProps {
  closeModal: () => void
  formMethods: AddressFormMethods
}

export const EditAddressModal = ({ closeModal, formMethods }: EditAddressModalProps): JSX.Element => {
  const [showFeedback, setShowFeedback] = useState(false)
  const { isUpdateSubmitting, onUpdatePersonGeneralData } = useUpdatePersonGeneral({
    successCallback: () => setShowFeedback(true)
  })

  return (
    <ModalGeneric 
      modalTitle='Editar meu endereço'
      onCloseModal={closeModal}
      feedbackShow={showFeedback}
      feedbackType='success'
      feedbackMessage='Seu endereço foi salvo com sucesso!'
      onSuccessClose={() => setShowFeedback(false)}
    >
      <S.Form onSubmit={formMethods.handleSubmit((data) => onUpdatePersonGeneralData(data))}>
        <AddressInputFields {...formMethods} />
        <Typography variant='content2' italic>
          * Preenchimento obrigatório.
        </Typography>
        <button type="submit">
          {isUpdateSubmitting ? <Spinner /> : 'Salvar endereço'}
        </button>
      </S.Form>
    </ModalGeneric>
  )
}